module.exports = require('./helpers/bundle-url').getBundleURL('EVgbq') + "linea.cd3a1e8c.svg";